import { Component } from "@angular/core";
import { ApiService } from "app/api.service";

@Component({
  selector: "app-import-statement-view",
  templateUrl: "./import-statement-view.component.html",
  styleUrls: ["./import-statement-view.component.scss"],
})
export class ImportStatementViewComponent {
  statementTransactions: any[] = [];
  openedGroups: any[] = [];
  data: any;
  statementType: any;
  statementType1: any;
  statement: any;
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.fetchStatement();
  }

  fetchStatement() {
    this.apiService.getData().subscribe(
      (response) => {
        this.statement = response;
        console.log("Data from API:", this.statement);
      },
      (error) => {
        console.log("Error fetching data:", error);
      }
    );
  }

  fetchData(statementId: number): void {
    const branch = localStorage.getItem('branch_id');
    this.apiService.getstatementview(statementId,branch).subscribe(
      (response: any) => {
        this.statementTransactions = response;
      },
      (error) => {
        console.log("Error fetching data:", error);
      }
    );
  }

  onSelectFormStatement() {
    const selectedStatement = this.statement.find(item => item.id === this.statementType1);
    if (selectedStatement) {
      this.fromStatementName = selectedStatement.name;
      this.fetchData(selectedStatement.id);
    }
  }
  onSelectTOStatement() {
    const selectedStatement = this.statement.find(item => item.id === this.statementType);
    if (selectedStatement) {
      this.toStatementName = selectedStatement.name;
      // Display statement ID without fetching data
      console.log("Selected Statement ID:", selectedStatement.id);
    }
  }
  
  submit(): void { }

  allComplete: boolean = false;

  isCr: boolean = false;

  creditParent: any = [];
  creditParentsChild: any = [];
  creditParentGroupId: any = [];
  creditParentChildGroupId: any = [];
  creditLedger: any = []; //for ledger
  allSubgruopCr: any = [];
  nestedSubgroup: any = [];
  selectedsubGroupId: any;
  creditGroupLedger:any=[]
  
  debitParent: any = [];
  debitParentsChild: any = [];
  debitParentChildGroupId: any = [];
  debitParentGroupId: any[] = [];
  allSubgruopDr: any = [];
  debitLedger: any = [];
  selectedsubGroupIdDr: any;
  checkedGroups: string[] = [];
  checkedSubgroups: string[] = [];
  checkedLedgers: string[] = [];
  selectedGroupIds: string[] = [];
  fromStatementName: string;
  toStatementName: string;
  debitGroupLedger:any=[]

  someComplete(xxx: any): boolean {
    return false;
  }

  setAll(completed: boolean) { }

  subgroupArrowClick(data: any) {
    console.log(data, "Arrow");
  }

  updateAllCompleteCr(checked: boolean, transactioncr: any) {
    if (checked) {
      this.creditParent.push(transactioncr);
      this.creditParentGroupId.push(transactioncr.group_id);
    } else {
      this.creditParent = this.creditParent.filter(
        (item: any) => item !== transactioncr
      );
      this.creditParentGroupId = this.creditParentGroupId.filter(
        (item: any) => item !== transactioncr.group_id
      );
    }
    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  updateAllCompleteCrChild(checked: boolean, subgroup: any) {
    if (checked) {
      this.creditParentsChild.push(subgroup);
      this.selectedsubGroupId = subgroup.group_id;
      if (
        this.creditParentGroupId.filter(
          (itm: any) => itm === subgroup.parent_group_id
        ).length === 0
      ) {
        if (
          this.statementTransactions[0].crTransactions.filter(
            (itm: any) => itm.group_id === subgroup.parent_group_id
          )[0]
        ) {
          this.creditParentGroupId.push(
            this.statementTransactions[0].crTransactions.filter(
              (itm: any) => itm.group_id === subgroup.parent_group_id
            )[0].group_id
          );
        } else {
          if (
            this.creditParentGroupId.filter(
              (itm: any) => itm === subgroup.parent_group_id
            ).length === 0
          ) {
            this.creditParentGroupId.push(subgroup.parent_group_id);
            const findParent = (id: number) => {
              const group = this.allSubgruopCr.find(
                (g: any) => g.group_id === id
              );
              if (group) {
                if (
                  this.creditParentGroupId.filter(
                    (itm: any) => itm !== group.parent_group_id
                  )
                ) {
                  this.creditParentGroupId.push(group.parent_group_id);
                }
                if (group.parent_group_id !== null) {
                  findParent(group.parent_group_id);
                }
              }
            };
            findParent(subgroup.parent_group_id);
          }
          this.creditParentChildGroupId.push(subgroup.parent_group_id);
        }
      }
      if (
        this.creditParentGroupId.filter((itm: any) => itm === subgroup.group_id)
          .length === 0
      ) {
        this.creditParentGroupId.push(subgroup.group_id);
      }
    } else {
      this.creditParentsChild = this.creditParentsChild.filter(
        (item: any) => item !== subgroup
      );
      this.creditParentGroupId = this.creditParentGroupId.filter(
        (item: any) => item !== subgroup.group_id
      );
      this.creditParentGroupId = this.creditParentGroupId.filter(
        (item: any) => item !== this.selectedsubGroupId
      );

      if (
        this.creditParentsChild.filter(
          (item: any) => item.parent_group_id === subgroup.parent_group_id
        ).length === 0
      ) {
        this.creditParentGroupId = this.creditParentGroupId
          .filter((item: any) => item !== subgroup.parent_group_id)
          .map((val: any) => val);

        const findParent = (id: number) => {
          const group = this.allSubgruopCr.find((g: any) => g.group_id === id);

          if (group) {
            const index = this.creditParentGroupId.indexOf(
              group.parent_group_id
            );

            if (index !== -1) {
              this.creditParentGroupId.splice(index, 1);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(subgroup.parent_group_id);
      }

      const findParent = (id: number) => {
        const group = this.allSubgruopCr.find((g: any) => g.group_id === id);

        if (group) {
          const index = this.creditParentGroupId.indexOf(group.parent_group_id);

          if (index !== -1) {
            this.creditParentGroupId.splice(index, 1);
          }
          if (group.parent_group_id !== null) {
            findParent(group.parent_group_id);
          }
        }
      };
      findParent(this.selectedsubGroupId);
    }
    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  nestedRemove(checked: boolean) {
    if (!checked) {
      for (let i = 0; i < this.allSubgruopCr.length; i++) {
        if (
          this.creditLedger.filter(
            (itm: any) => itm.parent_group_id === this.allSubgruopCr[i].group_id
          )
        ) {
          this.creditLedger = this.creditLedger.filter(
            (itm: any) => itm.parent_group_id !== this.allSubgruopCr[i].group_id
          );
        }
      }
    }
  }
  updateAllCompleteCrSubChild(checked: boolean, yyy: any) {
    if (checked) {
      this.creditLedger.push(yyy);
      if (
        this.creditParentGroupId.filter(
          (itm: any) => itm === yyy.parent_group_id
        ).length === 0
      ) {
        this.creditParentGroupId.push(yyy.parent_group_id);
        const findParent = (id: number) => {
          const group = this.allSubgruopCr.find((g: any) => g.group_id === id);
          if (group) {
            if (
              this.creditParentGroupId.filter(
                (itm: any) => itm !== group.parent_group_id
              )
            ) {
              this.creditParentGroupId.push(group.parent_group_id);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(yyy.parent_group_id);
      }
    } else {
      this.creditLedger = this.creditLedger.filter((item: any) => item !== yyy);
      if (
        this.creditLedger.filter(
          (item: any) => item.parent_group_id === yyy.parent_group_id
        ).length === 0
      ) {
        this.creditParentGroupId = this.creditParentGroupId
          .filter((item: any) => item !== yyy.parent_group_id)
          .map((val: any) => val);
        const findParent = (id: number) => {
          const group = this.allSubgruopCr.find((g: any) => g.group_id === id);
          if (group) {
            const index = this.creditParentGroupId.indexOf(
              group.parent_group_id
            );

            if (index !== -1) {
              this.creditParentGroupId.splice(index, 1);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(yyy.parent_group_id);
      }

      if (
        this.creditParentGroupId.find((itm: any) => itm !== yyy.parent_group_id)
      ) {
        this.creditLedger = this.creditLedger.filter(
          (item: any) => item.parent_group_id !== yyy.parent_group_id
        );
      }
    }

    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  updateAllCompleteCrSuperChild(checked: boolean, yyy: any) {

    if (checked) {
      this.creditGroupLedger.push(yyy);
      if (
        this.creditParentGroupId.filter(
          (itm: any) => itm === yyy.parent
        ).length === 0
      ) {
        this.creditParentGroupId.push(yyy.parent);
        const findParent = (id: number) => {
          const group = this.allSubgruopCr.find((g: any) => g.group_id === id);
          if (group) {
            if (
              this.creditParentGroupId.filter(
                (itm: any) => itm !== group.parent
              )
            ) {
              this.creditParentGroupId.push(group.parent);
            }
            if (group.parent !== null) {
              findParent(group.parent);
            }
          }
        };
        findParent(yyy.parent);
      }
    } else {
      this.creditGroupLedger = this.creditGroupLedger.filter((item: any) => item !== yyy);
      if (
        this.creditGroupLedger.filter(
          (item: any) => item.parent === yyy.parent
        ).length === 0
      ) {
        this.creditParentGroupId = this.creditParentGroupId
          .filter((item: any) => item !== yyy.parent)
          .map((val: any) => val);
        const findParent = (id: number) => {
          const group = this.allSubgruopCr.find((g: any) => g.group_id === id);
          if (group) {
            const index = this.creditParentGroupId.indexOf(
              group.parent
            );

            if (index !== -1) {
              this.creditParentGroupId.splice(index, 1);
            }
            if (group.parent !== null) {
              findParent(group.parent);
            }
          }
        };
        findParent(yyy.parent);
      }

      if (
        this.creditParentGroupId.find((itm: any) => itm !== yyy.parent)
      ) {
        this.creditGroupLedger = this.creditGroupLedger.filter(
          (item: any) => item.parent !== yyy.parent
        );
      }
    }

    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  //dr side

  updateAllCompleteDr(checked: boolean, transactiondr: any) {
    if (checked) {
      this.debitParent.push(transactiondr);
      this.debitParentGroupId.push(transactiondr.group_id);
    } else {
      this.debitParent = this.debitParent.filter(
        (item: any) => item !== transactiondr
      );
      this.debitParentGroupId = this.debitParentGroupId.filter(
        (item: any) => item !== transactiondr.group_id
      );
    }
    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  updateAllCompleteDrChild(checked: boolean, yyy: any) {
    if (checked) {
      this.debitParentsChild.push(yyy);
      this.selectedsubGroupIdDr = yyy.group_id;
      if (
        this.debitParentGroupId.filter(
          (itm: any) => itm === yyy.parent_group_id
        ).length === 0
      ) {
        if (
          this.statementTransactions[0].drTransactions.filter(
            (itm: any) => itm.group_id === yyy.parent_group_id
          )[0]
        ) {
          this.debitParentGroupId.push(
            this.statementTransactions[0].drTransactions.filter(
              (itm: any) => itm.group_id === yyy.parent_group_id
            )[0].group_id
          );
        } else {
          if (
            this.debitParentGroupId.filter(
              (itm: any) => itm === yyy.parent_group_id
            ).length === 0
          ) {
            this.debitParentGroupId.push(yyy.parent_group_id);
            const findParent = (id: number) => {
              const group = this.allSubgruopDr.find(
                (g: any) => g.group_id === id
              );
              if (group) {
                if (
                  this.debitParentGroupId.filter(
                    (itm: any) => itm !== group.parent_group_id
                  )
                ) {
                  this.debitParentGroupId.push(group.parent_group_id);
                }
                if (group.parent_group_id !== null) {
                  findParent(group.parent_group_id);
                }
              }
            };
            findParent(yyy.parent_group_id);
          }
          this.debitParentChildGroupId.push(yyy.parent_group_id);
        }
      }
      if (
        this.debitParentGroupId.filter((itm: any) => itm === yyy.group_id)
          .length === 0
      ) {
        this.debitParentGroupId.push(yyy.group_id);
      }
    } else {
      this.debitParentsChild = this.debitParentsChild.filter(
        (item: any) => item !== yyy
      );
      this.debitParentGroupId = this.debitParentGroupId.filter(
        (item: any) => item !== yyy.group_id
      );
      this.debitParentGroupId = this.debitParentGroupId.filter(
        (item: any) => item !== this.selectedsubGroupIdDr
      );

      if (
        this.debitParentsChild.filter(
          (item: any) => item.parent_group_id === yyy.parent_group_id
        ).length === 0
      ) {
        this.debitParentGroupId = this.debitParentGroupId
          .filter((item: any) => item !== yyy.parent_group_id)
          .map((val: any) => val);

        const findParent = (id: number) => {
          const group = this.allSubgruopDr.find((g: any) => g.group_id === id);

          if (group) {
            const index = this.debitParentGroupId.indexOf(
              group.parent_group_id
            );

            if (index !== -1) {
              this.debitParentGroupId.splice(index, 1);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(yyy.parent_group_id);
      }

      const findParent = (id: number) => {
        const group = this.allSubgruopDr.find((g: any) => g.group_id === id);

        if (group) {
          const index = this.debitParentGroupId.indexOf(group.parent_group_id);

          if (index !== -1) {
            this.debitParentGroupId.splice(index, 1);
          }
          if (group.parent_group_id !== null) {
            findParent(group.parent_group_id);
          }
        }
      };
      findParent(this.selectedsubGroupIdDr);
    }
    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }

  nestedRemoveDr(checked: boolean) {
    if (!checked) {
      for (let i = 0; i < this.allSubgruopDr.length; i++) {
        if (
          this.debitLedger.filter(
            (itm: any) => itm.parent_group_id === this.allSubgruopDr[i].group_id
          )
        ) {
          this.debitLedger = this.debitLedger.filter(
            (itm: any) => itm.parent_group_id !== this.allSubgruopDr[i].group_id
          );
        }
      }
    }
  }

  updateAllCompleteDrSubChild(checked: boolean, yyy: any) {
    if (checked) {
      this.debitLedger.push(yyy);
      if (
        this.debitParentGroupId.filter(
          (itm: any) => itm === yyy.parent_group_id
        ).length === 0
      ) {
        this.debitParentGroupId.push(yyy.parent_group_id);
        const findParent = (id: number) => {
          const group = this.allSubgruopDr.find((g: any) => g.group_id === id);
          if (group) {
            if (
              this.debitParentGroupId.filter(
                (itm: any) => itm !== group.parent_group_id
              )
            ) {
              this.debitParentGroupId.push(group.parent_group_id);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(yyy.parent_group_id);
      }
    } else {
      this.debitLedger = this.debitLedger.filter((item: any) => item !== yyy);
      if (
        this.debitLedger.filter(
          (item: any) => item.parent_group_id === yyy.parent_group_id
        ).length === 0
      ) {
        this.debitParentGroupId = this.debitParentGroupId
          .filter((item: any) => item !== yyy.parent_group_id)
          .map((val: any) => val);
        const findParent = (id: number) => {
          const group = this.allSubgruopDr.find((g: any) => g.group_id === id);
          if (group) {
            const index = this.debitParentGroupId.indexOf(
              group.parent_group_id
            );

            if (index !== -1) {
              this.debitParentGroupId.splice(index, 1);
            }
            if (group.parent_group_id !== null) {
              findParent(group.parent_group_id);
            }
          }
        };
        findParent(yyy.parent_group_id);
      }

      if (
        this.debitParentGroupId.find((itm: any) => itm !== yyy.parent_group_id)
      ) {
        this.debitLedger = this.debitLedger.filter(
          (item: any) => item.parent_group_id !== yyy.parent_group_id
        );
      }
    }

    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }
  
  updateAllCompleteDrSuperChild(checked:boolean,yyy: any) {
    if (checked) {
      this.debitGroupLedger.push(yyy);
      if (
        this.debitParentGroupId.filter(
          (itm: any) => itm === yyy.parent
        ).length === 0
      ) {
        this.debitParentGroupId.push(yyy.parent);
        const findParent = (id: number) => {
          const group = this.allSubgruopDr.find((g: any) => g.group_id === id);
          if (group) {
            if (
              this.debitParentGroupId.filter(
                (itm: any) => itm !== group.parent
              )
            ) {
              this.debitParentGroupId.push(group.parent);
            }
            if (group.parent !== null) {
              findParent(group.parent);
            }
          }
        };
        findParent(yyy.parent);
      }
    } else {
      this.debitGroupLedger = this.debitGroupLedger.filter((item: any) => item !== yyy);
      if (
        this.debitGroupLedger.filter(
          (item: any) => item.parent === yyy.parent
        ).length === 0
      ) {
        this.debitParentGroupId = this.debitParentGroupId
          .filter((item: any) => item !== yyy.parent)
          .map((val: any) => val);
        const findParent = (id: number) => {
          const group = this.allSubgruopDr.find((g: any) => g.group_id === id);
          if (group) {
            const index = this.debitParentGroupId.indexOf(
              group.parent
            );

            if (index !== -1) {
              this.debitParentGroupId.splice(index, 1);
            }
            if (group.parent !== null) {
              findParent(group.parent);
            }
          }
        };
        findParent(yyy.parent);
      }

      if (
        this.debitParentGroupId.find((itm: any) => itm !== yyy.parent)
      ) {
        this.debitGroupLedger = this.debitGroupLedger.filter(
          (item: any) => item.parent_group_id !== yyy.parent
        );
      }
    }

    this.allComplete =
      this.debitParentGroupId.length > 0 || this.creditParentGroupId.length > 0
        ? true
        : false;
  }



  getDebitStatementTransactions() {
    return this.statementTransactions;
  }

  toggleGroupStatement(statement: string) {
    const statementTransaction = this.statementTransactions.find(
      (t) => t.statement === statement
    );
    if (statementTransaction) {
      statementTransaction.isOpenStatement =
        !statementTransaction.isOpenStatement;
    }
  }

  isOpenStatement(statement: string) {
    const statementTransaction = this.statementTransactions.find(
      (t) => t.statement === statement
    );
    return statementTransaction ? statementTransaction.isOpenStatement : false;
  }

  toggleGroupDr(groupdr: string) {
    const transactionDr = this.statementTransactions
      .flatMap((st) => st.drTransactions)
      .find((t) => t.groupdr === groupdr);
    if (transactionDr) {
      transactionDr.isOpenDr = !transactionDr.isOpenDr;
    }
  }

  isOpendr(groupdr: string) {
    const transactionDr = this.statementTransactions
      .flatMap((st) => st.drTransactions)
      .find((t) => t.groupdr === groupdr);
    return transactionDr ? transactionDr.isOpenDr : false;
  }

  toggleGroupCr(groupcr: string) {
    const transactionCr = this.statementTransactions
      .flatMap((st) => st.crTransactions)
      .find((t) => t.groupcr === groupcr);
    if (transactionCr) {
      transactionCr.isOpenCr = !transactionCr.isOpenCr;
    }
  }

  isOpencr(groupcr: string) {
    const transactionCr = this.statementTransactions
      .flatMap((st) => st.crTransactions)
      .find((t) => t.groupcr === groupcr);
    return transactionCr ? transactionCr.isOpenCr : false;
  }

  toggleSubgroupDr(subgroup: any) {
    this.allSubgruopDr.push(subgroup);

    if (this.isSubgroupOpen(subgroup)) {
      this.openedGroups = this.openedGroups.filter((s) => s !== subgroup);
    } else {
      this.openedGroups.push(subgroup);
    }
    this.allSubgruopDr = [...new Set(this.allSubgruopDr.map((s: any) => s))];
  }

  toggleSubgroupCr(subgroup: any) {
    this.allSubgruopCr.push(subgroup);

    if (this.isSubgroupOpen(subgroup)) {
      this.openedGroups = this.openedGroups.filter((s) => s !== subgroup);
    } else {
      this.openedGroups.push(subgroup);
    }
    this.allSubgruopCr = [...new Set(this.allSubgruopCr.map((s: any) => s))];
  }
  isSubgroupOpen(subgroup: any) {
    return this.openedGroups.includes(subgroup);
  }

  importData() {
    if (!this.statementType || !this.statementType1) {
      console.error('Statement types are required.');
      return;
    }
    const selectedGroupIds = [];
    const addSubgroupGroupIdsCredit = (subgroups) => {
        if (subgroups && subgroups.length > 0) {
            for (const subgroup of subgroups) {
                if (this.creditParentGroupId.includes(subgroup.group_id)) {
                    selectedGroupIds.push(subgroup.group_id);
                }
                if (subgroup.subgroups && subgroup.subgroups.length > 0) {
                    addSubgroupGroupIdsCredit(subgroup.subgroups);
                }
            }
        }
    };
    const addSubgroupGroupIdsDebit = (subgroups) => {
        if (subgroups && subgroups.length > 0) {
            for (const subgroup of subgroups) {
                if (this.debitParentGroupId.includes(subgroup.group_id)) {
                    selectedGroupIds.push(subgroup.group_id);
                }
                if (subgroup.subgroups && subgroup.subgroups.length > 0) {
                    addSubgroupGroupIdsDebit(subgroup.subgroups);
                }
            }
        }
    };
    const handleCrTransactions = (crTransactions) => {
        for (const transactioncr of crTransactions) {
            if (this.creditParentGroupId.includes(transactioncr.group_id)) {
                selectedGroupIds.push(transactioncr.group_id);
            }
            addSubgroupGroupIdsCredit(transactioncr.subgroups);
        }
    };
    const handleDrTransactions = (drTransactions) => {
        for (const transactiondr of drTransactions) {
            if (this.debitParentGroupId.includes(transactiondr.group_id)) {
                selectedGroupIds.push(transactiondr.group_id);
            }
            addSubgroupGroupIdsDebit(transactiondr.subgroups);
           
        }
    };
    for (const statementTransaction of this.getDebitStatementTransactions()) {
        if (statementTransaction.crTransactions && statementTransaction.crTransactions.length > 0) {
            handleCrTransactions(statementTransaction.crTransactions);
        }
    }
    for (const statementTransaction of this.getDebitStatementTransactions()) {
        if (statementTransaction.drTransactions && statementTransaction.drTransactions.length > 0) {
            handleDrTransactions(statementTransaction.drTransactions);
        }
    }
    const payload = {
      from_statement_name: this.fromStatementName,
      from_statement_id: this.statementType1,
      to_statement_name: this.toStatementName,
      to_statement_id: this.statementType,
      selected_group_id: selectedGroupIds,
      selected_ledger_id: this.checkedLedgers
    };

    this.apiService.statementImport(payload).subscribe(
      (response) => {
        console.log('Response:', response);
        window.location.reload();
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }

  updateCheckedLedgers(event: any, ledger: any) {
    if (event.target.checked) {
      this.checkedLedgers.push(ledger.ledger_id);
    } else {
      const index = this.checkedLedgers.indexOf(ledger.ledger_id);
      if (index !== -1) {
        this.checkedLedgers.splice(index, 1);
      }
    }
  }
  updateCheckedgroupLedgers(event: any, groupLedgers: any) {
    if (event.target.checked) {
      this.checkedLedgers.push(groupLedgers.ledger_id);
    } else {
      const index = this.checkedLedgers.indexOf(groupLedgers.ledger_id);
      if (index !== -1) {
        this.checkedLedgers.splice(index, 1);
      }
    }
  }
}